// A thin strip above the shop's navbar, shown only to a signed-in admin,
// so Andre can hop back into the admin panel or sign out.
// Customers never see it: it renders nothing unless useAdminSession() says isAdmin.
import { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useAdminSession, signOut } from '../../lib/auth';
import { showToast } from '../ui/Toast';
import './AdminBar.css';

// Pages that have their own full-screen layout: no strip there.
export function isAdminBarHidden(pathname) {
  var p = (pathname || '').replace(/\/+$/, '') || '/';
  return p === '/admin' || p.indexOf('/admin/') === 0 ||
    p === '/checkout' || p.indexOf('/checkout/') === 0;
}

function AdminBarStrip() {
  var auth = useAdminSession();
  var _busy = useState(false);
  var busy = _busy[0];
  var setBusy = _busy[1];

  if (auth.loading || !auth.isAdmin) return null;

  var email = (auth.session && auth.session.user && auth.session.user.email) || 'admin';

  async function handleSignOut() {
    if (busy) return;
    setBusy(true);
    var res = await signOut();
    setBusy(false);
    if (res.error) showToast(res.error, 'error');
  }

  return (
    <div className="admin-bar" role="region" aria-label="Admin">
      <span className="admin-bar__who">
        Signed in as <strong className="admin-bar__email" title={email}>{email}</strong>
      </span>
      <span className="admin-bar__sep" aria-hidden="true">·</span>
      <Link to="/admin" className="admin-bar__link">Go to admin</Link>
      <span className="admin-bar__sep" aria-hidden="true">·</span>
      <button type="button" className="admin-bar__link admin-bar__btn" onClick={handleSignOut} disabled={busy}>
        {busy ? 'Signing out…' : 'Sign out'}
      </button>
    </div>
  );
}

export default function AdminBar() {
  var location = useLocation();
  if (isAdminBarHidden(location.pathname)) return null;
  return <AdminBarStrip />;
}
